export default "__VITE_ASSET__BqubmV8b__"